import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { InfoBarBaseComponent } from './info-bar-base.component';
import { GetCompanyUrlPipe } from '../../../shared/pipes/get-company-url.pipe';
import { CldPictureComponent } from '../../../shared/components/cld-picture/cld-picture.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ExpoButtonComponent } from '../../../shared/components/expo-button/expo-button.component';
import { DataSharingService } from '../data-sharing.service';
import { NgClass } from '@angular/common';
@Component({
    selector: 'info-bar',
    templateUrl: './info-bar.component.html',
    styleUrls: ['./info-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('FadeInfoBar', [
            transition('* => void', [
                animate(`500ms cubic-bezier(.17,.67,.27,1.26)`, style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: true,
    imports: [ExpoButtonComponent, MatIcon, MatButton, CldPictureComponent, GetCompanyUrlPipe, NgClass]
})
export class InfoBarComponent extends InfoBarBaseComponent {
  /* Is this component still useful to have? */
  constructor() {
    super();
  }
}
